appHost.actions.register({
    // #region Vars
    name: '288a.commerce.orderlist.toCart',
    // #endregion
    // #region Entry
    async execute(data, params) {
        let tCart = data;
        if (tCart == null) {
            return this.Cancel();
        }
        let tArgs = {
            title: appHost.localizer.t("client.Commerce.OrderList.Titel") + " " + tCart.cartNumber,
            message: appHost.localizer.t("client.Commerce.OrderList.ConvertToCartQuestion"),
            successCallback: async () => {
                //Delete
                await this.$appHost.api.put(`commerce/order-lists/${tCart.cartID}/change-to-cart`);
                //Store
                this.$store.commit('carts/load');
            }
        };
        return this.Window(await appHost.notification.showModal2("g-messages-question", tArgs));
    },
    // #endregion
});
export {};
